import MbaBottomNav from '@/components/page/mbaBottomNav'
import React, { FunctionComponent } from 'react'
import { usePathname } from 'next/navigation'
interface Prop {
  token?: string
}
const WebviewLayout: FunctionComponent<React.PropsWithChildren<Prop>> = (props) => {
  const pathName = usePathname()
  return (
    <div className={`${'pb-0'} bg-surfaceLow`}>
      {props.children}
      {pathName !== '/new-number' &&
        pathName !== '/dan/redirect' &&
        pathName !== '/simRecovery' &&
        pathName !== '/newnumberv2' &&
        pathName !== '/packageshift' &&
        pathName !== '/packageshift/afterDan' &&
        pathName !== '/afterDan' &&
        pathName !== '/paymentSuccess' &&
        pathName !== '/new-year-greeting' &&
        pathName !== '/service-branches' &&
        pathName !== '/confirmation' &&
        !pathName?.startsWith('/hitone')
        ? (
          <MbaBottomNav />
        )
        : (
          <></>
        )}
    </div>
  )
}

export default WebviewLayout
